import { getColorFromCSSVariable } from '@/app/components/search/Utilities';
import {
  IconBaggageCarryon,
  IconBaggageChecked,
  IconBaggagePersonal,
  IconNoBaggageCarryon,
  IconNoBaggageChecked,
  IconNoBaggagePersonal,
} from '@/app/common/icons/libraryIcons';
import type { JourneyContractBaggage } from '@/domainLogic/index.ts';
import { Text } from '@lmn/design-system';
import styled from 'styled-components';
import { useUrlSearchParams } from '../../UrlSearchParamsProvider';
import { BaggageContainer } from './styled';

const BaggageItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const BaggageSeparator = styled.div`
  width: 1px;
  height: 16px;
  background-color: ${({ theme }) => theme.kallisto.color.border.static.borderDisabled};
  align-self: center;
  flex-shrink: 0;
  margin: 0 4px;
`;

type BaggageProps = {
  baggage: JourneyContractBaggage;
  desktop?: boolean;
  numberOfBaggagePiecesIncluded?: number;
  showSeparators?: boolean;
};

export default function Baggage(props: BaggageProps) {
  const { baggage, desktop, numberOfBaggagePiecesIncluded, showSeparators } = props;
  const { adults, children } = useUrlSearchParams();

  const backpack = !!baggage;
  const carryOn = baggage?.hand;
  const checked = baggage?.hold;
  const width = desktop ? 20 : 20; // TODO Review sizes for desktop and mobile

  const numberOfLuggage = (adults ?? 0) + (children ?? 0);
  const showGroupLuggage = (numberOfBaggagePiecesIncluded ?? 0) > 0;

  const backpackCount = backpack ? numberOfLuggage : 0;
  const cabinBagCount = carryOn ? numberOfLuggage : 0;
  const checkedBagCount = checked ? numberOfLuggage : showGroupLuggage ? (numberOfBaggagePiecesIncluded ?? 0) : 0;

  return (
    <BaggageContainer>
      <BaggageItem>
        <Text variant="BodySmall">{backpackCount}</Text>
        {backpack ? (
          <IconBaggagePersonal
            color={getColorFromCSSVariable('--lmn-ds-color-text-static-textPrimary')}
            width={width}
          />
        ) : (
          <IconNoBaggagePersonal
            color={getColorFromCSSVariable('--lmn-ds-color-text-static-textSecondary')}
            width={width}
          />
        )}
      </BaggageItem>
      {showSeparators && <BaggageSeparator />}
      <BaggageItem>
        <Text variant="BodySmall">{cabinBagCount}</Text>
        {carryOn ? (
          <IconBaggageCarryon color={getColorFromCSSVariable('--lmn-ds-color-text-static-textPrimary')} width={width} />
        ) : (
          <IconNoBaggageCarryon
            color={getColorFromCSSVariable('--lmn-ds-color-text-static-textSecondary')}
            width={width}
          />
        )}
      </BaggageItem>
      {showSeparators && <BaggageSeparator />}
      <BaggageItem>
        <Text variant="BodySmall">{checkedBagCount}</Text>
        {checkedBagCount > 0 ? (
          <IconBaggageChecked color={getColorFromCSSVariable('--lmn-ds-color-text-static-textPrimary')} width={width} />
        ) : (
          <IconNoBaggageChecked
            color={getColorFromCSSVariable('--lmn-ds-color-text-static-textSecondary')}
            width={width}
          />
        )}
      </BaggageItem>
    </BaggageContainer>
  );
}
